import React, { Fragment, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

require('./DeviceTreeGroupNode.css');

export type Props = {
    id: string;
    label: string;
    depth: number;
    collapsed: boolean;
    filtered: boolean;
    numChildren: number;
    numMatchingChildren: number;
    onToggle(id: string): void;
};

export const DeviceTreeGroupNode = ({ id, label, depth, collapsed, filtered, numChildren, numMatchingChildren, onToggle }: Props) => {
    const { t } = useTranslation();

    const handleClick = useCallback(() => {
        onToggle(id);
    }, [ id, onToggle ]);

    return (
        <Fragment>
            <div
                className={ `label depth-${depth} group ${collapsed ? 'collapsed' : ''}` }
                onClick={ handleClick }
            >
                <i className="ui down triangle icon"/>
                <span>
                    { label }
                </span>
                <span className="subtitle">
                    { filtered
                        ? `(${t('DEVICES.FILTERS.M_OF_N', [ numMatchingChildren, numChildren ])})`
                        : `(${numChildren})`
                    }
                </span>
            </div>
        </Fragment>
    );
};
